    <kendo-datepicker [readonly]="!!options.readonly" [formControl]="control" [format]="dateFormat"></kendo-datepicker>